exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (min-width:480px){.wrap{width:380px;position:absolute;top:40%;left:50%;margin:5px;transform:translate(-50%,-50%)}}@media screen and (max-width:480px){.wrap{width:100%;position:absolute;padding:10px;margin-top:20px;top:40%;left:50%;transform:translate(-50%,-50%)}}.selectorWidth{width:-webkit-fill-available}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Screens/Login/login.css
// module id = 375
// module chunks = 0